/* Source: /home/ubuntu/libredraw/frontend/editor/AuthModal.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { jacLogin, jacSsoLogin } from "@jac/runtime";
import { registerAccount, promoteGuest } from "./collab.tsx";
import { useModalA11y } from "./modalA11y.ts";
import { X } from "lucide-react";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
function AuthModal(props) {
  const {onClose: onClose = null, onAuthed: onAuthed = null, isGuest: isGuest = false, reason: reason = ""} = props;
  const [isSignup, setIsSignup] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if ((reason !== "")) {
      setIsSignup(true);
    }
  }, []);
  async function submit(e) {
    e.preventDefault();
    setError("");
    if ((isSignup && isGuest)) {
      if ((!email || !password)) {
        setError("Enter an email and a password.");
        return;
      }
      setLoading(true);
      let gpw = "";
      let raw = localStorage.getItem("libredraw:guest");
      if (raw) {
        let g = JSON.parse(raw);
        gpw = String(g["p"]);
      }
      let okp = await promoteGuest(email, password, gpw);
      setLoading(false);
      if (okp) {
        if (onAuthed) {
          onAuthed();
        }
      } else {
        setError("Couldn't upgrade - that email may already be in use.");
      }
      return;
    }
    if ((!username || !password)) {
      setError("Enter a username and password.");
      return;
    }
    setLoading(true);
    if (isSignup) {
      let ok0 = await registerAccount(username, password, email);
      if (ok0) {
        let ok = await jacLogin(username, password);
        setLoading(false);
        if (ok) {
          if (onAuthed) {
            onAuthed();
          }
        } else {
          setError("Account created - please log in.");
          setIsSignup(false);
        }
      } else {
        setLoading(false);
        setError("Sign up failed - try a different username.");
      }
    } else {
      let ok = await jacLogin(username, password);
      setLoading(false);
      if (ok) {
        if (onAuthed) {
          onAuthed();
        }
      } else {
        setError("Invalid username or password.");
      }
    }
  }
  async function sso(platform) {
    await jacSsoLogin(platform);
  }
  let dialogRef = useModalA11y(() => {
    if (onClose) {
      onClose(null);
    }
  });
  return __jacJsx("div", {"className": "fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm", "onClick": onClose}, [__jacJsx("div", {"ref": dialogRef, "role": "dialog", "aria-modal": "true", "aria-labelledby": "authmodal-title", "className": "w-[400px] rounded-2xl border border-border bg-card p-7 shadow-pop", "onClick": e => {
    e.stopPropagation();
  }}, [__jacJsx("div", {"className": "flex items-center justify-between"}, [__jacJsx("div", {"className": "flex items-center gap-2"}, [__jacJsx("img", {"src": "/assets/logo.png", "alt": "LibreDraw", "className": "size-7"}, []), __jacJsx("span", {"className": "text-lg font-semibold tracking-tight"}, ["LibreDraw"])]), __jacJsx("button", {"onClick": onClose, "title": "Close", "className": "flex size-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground"}, [__jacJsx(X, {"size": 18}, [])])]), __jacJsx("h1", {"id": "authmodal-title", "className": "mt-4 text-base font-semibold"}, [((reason === "supporter_save") ? "You're a Supporter - thank you! \ud83d\udc9c" : (isSignup ? "Create your account" : "Welcome back"))]), __jacJsx("p", {"className": "mb-4 mt-1 text-sm text-muted-foreground"}, [((reason === "supporter_save") ? "Add an email and password to save your Supporter membership across devices - your account is upgraded in place, so nothing is lost." : ((reason === "supporter") ? "A free account keeps your Supporter membership with you across devices." : (isSignup ? (isGuest ? "Keep your current diagrams, sync across devices, and share." : "Sign up to sync across devices and share.") : "Log in to sync across devices and share.")))]), __jacJsx("div", {"className": "flex flex-col gap-2"}, [__jacJsx("button", {"onClick": _e => {
    sso("google");
  }, "className": "flex h-10 items-center justify-center gap-2 rounded-lg border border-border bg-card text-sm font-medium transition-colors hover:bg-accent"}, [__jacJsx("span", {"className": "size-4 rounded-full bg-gradient-to-br from-[#4285F4] to-[#34A853]"}, []), " Continue with Google"]), __jacJsx("button", {"onClick": _e => {
    sso("github");
  }, "className": "flex h-10 items-center justify-center gap-2 rounded-lg border border-border bg-card text-sm font-medium transition-colors hover:bg-accent"}, [__jacJsx("span", {"className": "size-4 rounded-full bg-foreground"}, []), " Continue with GitHub"])]), __jacJsx("div", {"className": "my-4 flex items-center gap-3 text-xs text-muted-foreground"}, [__jacJsx("div", {"className": "h-px flex-1 bg-border"}, []), " or ", __jacJsx("div", {"className": "h-px flex-1 bg-border"}, [])]), __jacJsx("form", {"onSubmit": submit, "className": "flex flex-col gap-3"}, [(error ? __jacJsx("div", {"className": "rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive"}, [error]) : null), (!(isSignup && isGuest) ? __jacJsx("input", {"type": "text", "value": username, "onChange": e => {
    setUsername(e.target.value);
  }, "placeholder": "Username", "className": "h-10 rounded-lg border border-input bg-background px-3 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"}, []) : null), (isSignup ? __jacJsx("input", {"type": "email", "value": email, "onChange": e => {
    setEmail(e.target.value);
  }, "placeholder": "Email (so people can share diagrams with you)", "className": "h-10 rounded-lg border border-input bg-background px-3 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"}, []) : null), __jacJsx("input", {"type": "password", "value": password, "onChange": e => {
    setPassword(e.target.value);
  }, "placeholder": "Password", "className": "h-10 rounded-lg border border-input bg-background px-3 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"}, []), __jacJsx("button", {"type": "submit", "disabled": loading, "className": "mt-1 h-10 rounded-lg bg-primary text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 disabled:opacity-60"}, [(loading ? "Please wait..." : (isSignup ? "Sign up" : "Log in"))])]), __jacJsx("button", {"onClick": _e => {
    setIsSignup(!isSignup);
    setError("");
  }, "className": "mt-4 w-full text-center text-sm text-muted-foreground hover:text-foreground"}, [(isSignup ? "Already have an account? Log in" : "Need an account? Sign up")])])]);
}
/*jac:refresh-boundary*/;
export {AuthModal};
//# sourceMappingURL=AuthModal.js.map
